import { Eye, ChevronDown } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const InquiriesTab = ({ inquiries, updateStatus, setViewingInquiry }) => (
  <div className="bg-white border border-[#E6E4DD]">
    <div className="p-6 border-b border-[#E6E4DD]"><h2 className="font-medium text-[#1C1C1A]">Inquiries</h2></div>
    <div className="overflow-x-auto">
      <table className="admin-table">
        <thead><tr><th>Name</th><th>Contact</th><th>Status</th><th>Actions</th></tr></thead>
        <tbody>
          {inquiries.map(inq => (
            <tr key={inq.id}>
              <td><p className="font-medium">{inq.name}</p>{inq.company && <p className="text-xs text-[#6B6A65]">{inq.company}</p>}</td>
              <td><p className="text-sm">{inq.email}</p><p className="text-xs text-[#6B6A65]">{inq.phone}</p></td>
              <td><span className={`px-2 py-1 text-xs ${inq.status === 'contacted' ? 'bg-blue-100 text-blue-800' : inq.status === 'closed' ? 'bg-gray-100 text-gray-800' : 'bg-yellow-100 text-yellow-800'}`}>{inq.status}</span></td>
              <td>
                <div className="flex items-center gap-2">
                  <button onClick={() => setViewingInquiry(inq)} className="p-2 hover:bg-[#F7F5F0]" data-testid={`view-inquiry-${inq.id}`}><Eye size={16} /></button>
                  <DropdownMenu>
                    <DropdownMenuTrigger className="p-2 hover:bg-[#F7F5F0]"><ChevronDown size={16} /></DropdownMenuTrigger>
                    <DropdownMenuContent>
                      <DropdownMenuItem onClick={() => updateStatus('inquiries', inq.id, 'contacted')}>Mark Contacted</DropdownMenuItem>
                      <DropdownMenuItem onClick={() => updateStatus('inquiries', inq.id, 'closed')}>Close</DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </div>
              </td>
            </tr>
          ))}
          {inquiries.length === 0 && <tr><td colSpan={4} className="text-center py-12 text-[#6B6A65]">No inquiries yet.</td></tr>}
        </tbody>
      </table>
    </div>
  </div>
);

export default InquiriesTab;
